module.exports = __webpack_public_path__ + "static/media/file-lock-alt.25cd43db.svg";